// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../shared/components/labeled-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const DealerTransferHistoryCriteria = props =>
    <div className='dealer-transfer-history-criteria'>
        <div className='history-to-display-criteria'>
            <LabeledCriteria
                className='history-to-display-criteria'
                isRequired={true}
                label='HISTORY_TO_DISPLAY'
                max='999'
                min='1'
                onInputChange={props.onHistoryToDisplayChange}
                placeholder='ENTER_A_NUMBER_BETWEEN_0_AND_1000'
                type='number'
                value={props.historyToDisplay}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.onCriteriaReset}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateDealerHistoryReport}
            showExport={true}
            showReport={true}
        />
    </div>;

DealerTransferHistoryCriteria.displayName = 'DealerTransferHistoryCriteria';
DealerTransferHistoryCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    historyToDisplay: PropTypes.number,
    onCreateDealerHistoryReport: PropTypes.func.isRequired,
    onCriteriaReset: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onHistoryToDisplayChange: PropTypes.func.isRequired
};

export default DealerTransferHistoryCriteria;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/components/dealer-transfer-history-report-criteria.js